export interface runReportData {
  reportsVersion: boolean;
}

const runReportDataInitialState: runReportData = {
  reportsVersion: false,
};

export default runReportDataInitialState;
